import { Record, List } from "immutable";
import { STATE_STATUS } from "../constants";


export class DisbursalRequestRecord extends Record({
    id: null,
    seller: null,
    invoices: null,
    job: null,
    totalParsedInvoices: 0,
    status: null
}) {

    getStage() {
        if(this.status === STATE_STATUS.CREATING) {
            return "Uploading Invoices";
        } else if(this.status === STATE_STATUS.CREATE_FAILED) {
            return "Upload Failed";
        } else if(this.status === STATE_STATUS.CREATED) {
            if(this.totalParsedInvoices < this.job.no_of_invoice) {
                return "Processing Invoices";
            } else if(this.totalParsedInvoices === this.job.no_of_invoice) {
                return "Processed Invoices";
            }
        }
    }

    isLoading() {
        if(this.status === STATE_STATUS.CREATING) {
            return true;
        } else if(this.status === STATE_STATUS.CREATED) {
            if(this.totalParsedInvoices < this.job.no_of_invoice) {
                return true;
            }
        }
        return false;
    }

    isProcessed() {
        if(this.status === STATE_STATUS.CREATED && this.totalParsedInvoices === this.job.no_of_invoice) {
            return true;
        } 
        return false;
    }


    isError() {
        return this.status === STATE_STATUS.CREATE_FAILED;
    }

    isJobCreated() {
        return !!this.job;
    }

    getInvoiceCount() {
        return this.invoices.length;
    }

    approvedInvoices() {
        return this.job.approved_invoices;
    }

    totalInvoices() {
        return this.job.no_of_invoice;
    }

}


export class DisbursalJobRecord extends Record({
    id: null,
    job: null,
    invoices: new List([]),
    status: STATE_STATUS.UNFETCHED,
    invoicesStatus: STATE_STATUS.UNFETCHED
}) {


    isJobEditable(isChecker) {
        if(isChecker && ["Review Closed", "Review Pending", "Review Initialized"].includes(this.job && this.job.stage)) {
            return true;
        } else if (this.job && this.job.stage === "Processed") {
            return true;
        }
        return false;
    }

}